import galleryimg from '../assets/images/gallery.png';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { useState, useEffect } from "react";
import img4 from '../assets/images/img4.png';
import img5 from '../assets/images/img5.png';
import { useDispatch, useSelector } from "react-redux";
import { getAlbums } from '../slices/gallery';
import empty_table from '../assets/images/empty_table.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Gallery = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { albums } = useSelector((state) => state.gallery);
    
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(getAlbums())
    }, []);

    const [photoIndex, setPhotoindex] = useState(1);
    const [isOpen, setIsopen] = useState(false);

    const viewGallery = (id) => {
        navigate('/gallery/' + id);
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="row">
                    <div className='col-md-12'>
                        <div className='section-title' id='heading_title'>
                            <h1><span className='font-color-1'>{t('photo_gallery')}</span></h1>
                           
                        </div>
                    </div>

                    {
                        albums != null ?
                            albums?.map((item, index) => {
                                return (
                                    <div className="col-md-3 mb-4 itemBox" onClick={() => viewGallery(item.id)}>
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <img src={item.image_path} class="mobile-img"  width={260} height={205} />
                                            </div>
                                            <div className="card-footer post-footer">
                                                <h5 className='mb-0 gallery-title'>{item.name}</h5>
                                                <h6 className='mb-0'>{item.created_at}</h6>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                            :
                            <div className='emptyTable'>
                                <img src={empty_table} />
                                <h5 className='mt-2-new'>No Data Found</h5>
                            </div>
                    }

                </div>
            </section>
        </div>
    );
}
export default Gallery;